//Mapping display names to validation property names
export enum PromotionExpirationExcelColumnHeaders {
    agreementNumber = "Agreement Number",
    controlNumber = "Control Number",
    customerId = "Customer ID",
    customerName = "Customer Name",
    customerAddress = "Customer Address",

    segment = "Segment",
    segmentDescription = "Segment Description",
    tier = "Tier",
    tierDescription = "Tier Description",
    channel = "Channel",
    channelDescription = "Channel Description",
    buyingGroup = "Buying Group",
    buyingGroupDescription = "Buying Group Description",
    corporateAffiliation = "Corporate Affiliation",
    corporateAffiliationDescription = "Corporate Affiliation Description",
    countryCode = "Country Code",
    countryDescription = "Country Description",
    priceZone = "Price Zone",
    priceZoneDescription = "Price Zone Description",
    freightZone = "Freight Zone",

    productLine = "Product Line Number",
    productLineDescription = "Product Line Description",
    productLineCategory = "Product Category",
    productLineCategoryDescription = "Product Category Description",

    itemNumber = "Item Number",
    itemDescription = "Item Description",
    manufacturerNumber = "Manufacturer Number",
    gtin = "GTIN",

    employee = "Employee Responsible For Pricing",
    jobType = "Job Type",
    jobTypeDescription = "Job Type Desc",
    supplierFlag = "Supplier Flag",

    promotionId = "Promotion ID",
    promotionIdDescription = "Promotion ID Description",
    uom = "Unit of Measure",
    promotionAmount = "Promotion Amount",
    promotionPercent = "Promotion Percent",

    minimumCode = "Minimum Code",
    minimumValue = "Minimum Value",
    minimumDescription = "Minimum Description",

    maxCode = "Max Code",
    maximumValue = "Maximum Value",
    maximumDescription = "Maximum Description",

    beginOrderDate = "Begin Order Date",
    endOrderDate = "End Order Date",
    extendOrderDate = "Extend Order End Date",

    beginDeliveryDate = "Begin Delivery Date",
    endDeliveryDate = "End Delivery Date",
    extendDeliveryDate = "Extend Delivery End Date",

    contactEmail = "Contact Email",
    action = "Extend/Delete/Cancel/New",

    newPromotionAmount = "New Promotion Amount",
    newPromotionUOM = "New Promotion UOM",
    newBeginningOrderDate = "New Beginning Order Date",
    newEndingOrderDate = "New Ending Order Date",
    newBeginningDeliveryDate = "New Beginning Delivery Date",
    newEndingDeliveryDate = "New Ending Delivery Date",

    comments = "Comments"
}

//Mapping raw excel property names to validation model property names
export enum PromotionExpirationTemplateErrorKeys {
    agreementNumber = "AGREEMENTNUMBER",
    controlNumber = "CONTROLNUMBER",
    customerId = "CUSTOMERID",
    customerName = "CUSTOMERNAME",
    customerAddress = "CUSTOMERADDRESS",

    segment = "SEGMENT",
    segmentDescription = "SEGMENTDESC",
    tier = "TIER",
    tierDescription = "TIERDESC",
    channel = "CHANNEL",
    channelDescription = "CHANNELDESC",
    buyingGroup = "BUYINGGROUP",
    buyingGroupDescription = "BUYINGGROUPDESC",
    corporateAffiliation = "CORPORATEAFFILIATION",
    corporateAffiliationDescription = "CORPORATEAFFILIATIONDESC",
    countryCode = "COUNTRYCODE",
    countryDescription = "COUNTRYDESC",
    priceZone = "PRICEZONE",
    priceZoneDescription = "PRICEZONEDESC",
    freightZone = "FREIGHTZONE",

    productLine = "PRODUCTLINE",
    productLineDescription = "PRODUCTLINEDESC",
    productLineCategory = "PRODUCTCATEGORY",
    productLineCategoryDescription = "PRODUCTCATEGORYDESC",

    itemNumber = "ITEMNUMBER",
    itemDescription = "ITEMDESC",
    manufacturerNumber = "MANUFACTURERSNUMBER",
    gtin = "GTIN",

    employee = "EMPLOYEERESPONSIBLEPRICING",
    jobType = "JOBTYPE",
    jobTypeDescription = "JOBTYPEDESC",
    supplierFlag = "SUPPLIERFLAG",

    promotionId = "PROMOTIONID",
    promotionIdDescription = "PROMOTIONIDDESC",
    uom = "UOM",
    promotionAmount = "PROMOTIONAMOUNT",
    promotionPercent = "PROMOTIONPERCENT",

    minimumCode = "MINIMUMCODE",
    minimumValue = "MINIMUMVALUE",
    minimumDescription = "MINIMUMDESC",

    maxCode = "MAXCODE",
    maximumValue = "MAXIMUMVALUE",
    maximumDescription = "MAXIMUMDESC",

    beginOrderDate = "BEGINORDERDATE",
    endOrderDate = "ENDORDERDATE",
    extendOrderDate = "EXTENDORDERENDDATE",

    beginDeliveryDate = "BEGINDELIVERYDATE",
    endDeliveryDate = "ENDDELIVERYDATE",
    extendDeliveryDate = "EXTENDDELIVERYENDDATE",

    contactEmail = "CONTACTEMAIL",
    action = "EXTEND/DELETE/CANCEL/NEW",

    newPromotionAmount = "NEWPROMOTIONAMOUNT",
    newPromotionUOM = "NEWPROMOTIONUOM",
    newBeginningOrderDate = "NEWBEGINNINGORDERDATE",
    newEndingOrderDate = "NEWENDINGORDERDATE",
    newBeginningDeliveryDate = "NEWBEGINNINGDELIVERYDATE",
    newEndingDeliveryDate = "NEWENDINGDELIVERYDATE",

    comments = "COMMENTS"
}

//Mapping raw excel property names to request/response property names
//for the template history excel conversion
export enum PromotionExpirationTemplateApiResponseKeys {
    AGREEMENTNUMBER = "AGREEMENTNUMBER",
    CONTROLNUMBER = "CONTROLNUMBER",
    CUSTOMERID = "CUSTOMERID",
    CUSTOMERNAME = "CUSTOMERNAME",
    CUSTOMERADDRESS = "CUSTOMERADDRESS",

    SEGMENT = "SEGMENT",
    SEGMENTDESCRIPTION = "SEGMENTDESC",
    TIER = "",
    TIERDESCRIPTION = "TIERDESC",
    CHANNEL = "CHANNEL",
    CHANNELDESCRIPTION = "CHANNELDESC",
    BUYINGGROUP = "BUYINGGROUP",
    BUYINGGROUPDESCRIPTION = "BUYINGGROUPDESC",
    CORPORATEAFFILIATION = "CORPORATEAFFILIATION",
    CORPORATEAFFILIATIONDESCRIPTION = "CORPORATEAFFILIATIONDESC",
    COUNTRYCODE = "COUNTRYCODE",
    COUNTRYDESCRIPTION = "COUNTRYDESC",
    PRICEZONE = "PRICEZONE",
    PRICEZONEDESCRIPTION = "PRICEZONEDESC",
    FREIGHTZONE = "FREIGHTZONE",

    PRODUCTLINE = "PRODUCTLINE",
    PRODUCTLINEDESCRIPTION = "PRODUCTLINEDESC",
    PRODUCTLINECATEGORY = "PRODUCTCATEGORY",
    PRODUCTLINECATEGORYDESCRIPTION = "PRODUCTCATEGORYDESC",

    ITEMNUMBER = "ITEMNUMBER",
    ITEMDESCRIPTION = "ITEMDESC",
    MANUFACTURERNUMBER = "MANUFACTURERSNUMBER",  
    GTIN = "GTIN",  

    EMPLOYEERESPONSIBLENAME = "EMPLOYEERESPONSIBLEPRICING",
    JOBTYPE = "JOBTYPE",
    JOBTYPEDESCRIPTION = "JOBTYPEDESC",
    SUPPLIERINDICATOR = "SUPPLIERFLAG",

    PROMOTIONID = "PROMOTIONID",
    PROMOTIONIDDESCRIPTION = "PROMOTIONIDDESC",
    PROMOTIONAMOUNT = "PROMOTIONAMOUNT",
    UNITOFMEASURE = "UOM",
    PROMOTIONPERCENT = "PROMOTIONPERCENT",

    MINIMUMVALUE = "MINIMUMVALUE",
    MINIMUMCODE = "MINIMUMCODE",
    MINIMUMDESCRIPTION = "MINIMUMDESC",

    MAXIMUMVALUE = "MAXIMUMVALUE",
    MAXCODE = "MAXCODE",
    MAXIMUMDESCRIPTION = "MAXIMUMDESC",

    BEGINORDERDATE = "BEGINORDERDATE",
    ENDORDERDATE = "ENDORDERDATE",
    EXTENDORDERDATE = "EXTENDORDERENDDATE",

    BEGINDELIVERYDATE = "BEGINDELIVERYDATE",
    ENDDELIVERYDATE = "ENDDELIVERYDATE",
    EXTENDDELIVERYDATE = "EXTENDDELIVERYENDDATE",

    CONTACTEMAIL = "CONTACTEMAIL",
    ACTION = "EXTEND/DELETE/CANCEL/NEW",

    NEWPROMOTIONAMOUNT = "NEWPROMOTIONAMOUNT",
    NEWPROMOTIONUOM = "NEWPROMOTIONUOM",
    NEWBEGINNINGORDERDATE = "NEWBEGINNINGORDERDATE",
    NEWENDINGORDERDATE = "NEWENDINGORDERDATE",
    NEWBEGINNINGDELIVERYDATE = "NEWBEGINNINGDELIVERYDATE",
    NEWENDINGDELIVERYDATE = "NEWENDINGDELIVERYDATE",

    COMMENTS = "COMMENTS"
}
